module.exports = __webpack_public_path__ + "static/technical-wp-dbe8e2d9789943f0e34fa6b242434733.jpeg";